module.exports = __webpack_public_path__ + "img/button_robert.aa096226.png";